import React, {useEffect, useState} from "react";
import axios from "axios";
import "../../../CSS/TablaHerramientas.css"
import {URI} from '../../../Conexiones/Conexion';
import '../../../CSS/Empleados.css'
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import { SlLogout,SlLogin } from "react-icons/sl";
import { getToken } from "../../../Conexiones/Conexion";

const ModalEntrada = () => {
    const navigate = useNavigate()
    const obraId = parseInt(sessionStorage.getItem("obra"))
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    const idUsuario = usuario[0].idUsuario
    const [lista, setLista] = useState([])
    const [obra,setObra] = useState('')
    const [idsh, setIdsh] = useState(null)
    const [idh,setIdh] = useState(null)
    const [estH, setEsth] = useState(null)
    const [nombreH, setNombreH] = useState(null)
    const [codigoH, setCodigoH] = useState(null)
    const [verificar, setVerificar] = useState(null)
    const [observacionH, setObservacionH] = useState(null)
    //const [empleados, setEmpleados] = useState([]);
    const [idemp,setIdemp] = useState()
    const [nomEmp, setNomEmp] = useState()
    const [pinEmpleado, setPinEmpleado] = useState()
    const [salidaHerramientas, setSalidaHerramientas] = useState([])
    useEffect( ()=>{
        const obraId = parseInt(sessionStorage.getItem("obra"))
        const getHerramientas = async () =>{
            const res = await axios.get(URI + 'herramientasalida/'+obraId,{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                })
            setSalidaHerramientas(res.data)
        }
        getHerramientas()
    }, [])
    /*useEffect( ()=>{
        const getEmpleados = async () =>{
            const res = await axios.get(URI+'empleados/')
            setEmpleados(res.data)
        }
        getEmpleados()
    }, [])*/
    
    useEffect(() => {
        const obraId = parseInt(sessionStorage.getItem("obra"))
        const getObras = async () => {
            const res = await axios.get(URI+'obras/'+obraId,{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                })
            setObra(res.data.nombreObra);
        };
        getObras();
    }, );
    const addTool = async () =>{
        const newTools = salidaHerramientas.filter((item) => item.idHerramienta !== idh) ;
        setSalidaHerramientas(newTools)
        const newTool = {idsL: idsh, idL: idh, codL: codigoH, 
            nomL: nombreH, estL: estH, danL: verificar, notaL:observacionH}
        setLista([...lista, newTool])
        setIdsh(null)
        setIdh(null)
        setCodigoH(null)
        setNombreH(null)
        setEsth(null)
        setVerificar(null)
        setObservacionH(null)
        var nota = document.getElementById("divobservacion");
        nota.style.display = "none";
        const inpobs = document.getElementById('inputobservacion');
        inpobs.value = null;
        document.getElementById('opcion1').checked = false;
        document.getElementById('opcion2').checked = false;
    }
    const deletTool = async(ids, id, cod, nom, sta) => {
        const newTools = lista.filter((item) => item.idL !== id) ;
        setLista(newTools)
        const newTool = {idSalHer:ids, idHerramienta: id, 
            codigoHer: cod, nombreHer: nom, estadoSal: sta}
        setSalidaHerramientas([...salidaHerramientas, newTool])
    }
    const cancelar = async () => {
        if(lista.length === 0 ){
            window.location.reload()
        }else{
            Swal.fire({
                title: '¿SEGURO QUE QUIERES SALIR?',
                text: "UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS",
                icon: 'warning',
                iconColor:'#1e2c4f',
                color: '#1e2c4f',
                showCancelButton: true,
                confirmButtonColor: '#1e2c4f',
                cancelButtonColor: '#d33',
                confirmButtonText: 'SALIR',
                cancelButtonText: 'CANCELAR'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            })   
        } 
    }
    const confirmarCredenciales = async (e) =>{
        e.preventDefault()
        var listaHerramientas = JSON.stringify(lista);
        await axios.post(URI+'entradaherramientas/',{lista:listaHerramientas,idObra:obraId, idEntrega:idemp, idRecibe:idUsuario, pinEmp:pinEmpleado},{
            headers: {
                'Content-Type': 'application/json',
            },
            }).then(
            res => {
                if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                        )
                }else{
                    if(res.data.message==="¡Herramientas agregadas!"){
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: '¡HERRAMIENTAS DEVUELTAS!',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/Herramientas/Entrada-Herramientas')
                                window.location.reload();
                            } 
                        })
                        
                    }else{
                        Swal.fire({
                            title: '¡ERROR!',
                            text:res.data.message,                 
                            icon: 'error',
                            confirmButtonColor: 'red',
                            allowOutsideClick: false,
                            confirmButtonText: 'ACEPTAR'
                        })
                        const pin = document.getElementById('pin');
                        pin.value = null;
                    }
                }
            }
        ).catch(
            err => {
                if(err.message === "Network Error"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                    )
                }else{
                    Swal.fire(
                        'Falla en el servidor...',
                        err.message,
                        'question'
                    )
                }
            }
        )
    }

    const datosHerramienta = (ish,ih,ch,nh,es,ide,ne) => {
        setIdsh(ish)
        setIdh(ih)
        setCodigoH(ch)
        setNombreH(nh)
        setEsth(es)
        setIdemp(ide)
        setNomEmp(ne)
    }
    const notasi = () => {
        var nota = document.getElementById("divobservacion");
        nota.style.display = "block";
    }
    const notano = () => {
        var nota = document.getElementById("divobservacion");
        nota.style.display = "none";
    }
   
    return (
        <div>            
            <div className="modal fade" id="modal-entrada" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="false">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header btncolor" >
                            <h5 className="modal-title " id="exampleModalLabel">DEVOLVER HERRAMIENTAS</h5>
                            <button type="button" className="btn-close bg-white" onClick={cancelar} aria-label="Close" ></button>
                        </div>
                        <div className="modal-body" >
                            <div className="mb-3">
                                <h5 className="modal-title text-uppercase" id="exampleModalLabel">OBRA: {obra}</h5>
                            </div>
                            <div style={{width:'100%'}}>
                                <div className="lista">
                                    <div><h5>LISTA DE HERRAMIENTAS EN OBRA</h5></div>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>CODIGO</th>
                                                    <th>HERRAMIENTA</th>
                                                    <th><SlLogin/></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {salidaHerramientas.map(h =>{
                                                    return(
                                                        h.estadoSal === "prestado"? (
                                                            <tr key={h.idSalHer}>
                                                                <td className="text-uppercase">{h.codigoHer}</td>
                                                                <td className="text-uppercase">{h.nombreHer}</td>
                                                                <td>
                                                                    <button className='btn btncolor' 
                                                                        data-bs-toggle="modal" data-bs-target="#modal-agregar-nota"
                                                                        onClick={()=>datosHerramienta(
                                                                            h.idSalHer, h.idHerramienta, h.codigoHer, 
                                                                            h.nombreHer, h.estadoSal, h.idRecibe, h.nombreEmp
                                                                            )}>
                                                                        +
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ):(null)
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="lista">
                                    <div><h5>AGREGADAS</h5></div>
                                    <div className="table-responsive" style={{backgroundColor:'#efefef', borderRadius:'20px'}}>
                                        {lista.length === 0  ?(<div><p>VACIO</p></div>):(
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th >CODIGO</th>
                                                    <th >NOMBRE</th>
                                                    <th >DAÑADA</th>
                                                    <th><SlLogout/></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                lista.map(item=>{
                                                    return(
                                                        <tr key={item.idL} className="text-uppercase">
                                                            <td >{item.codL}</td>
                                                            <td >{item.nomL}</td>
                                                            <td >{item.danL}</td>
                                                            <td>
                                                                <span className="bi bi-trash" style={{color:'red', cursor:'pointer'}} title="ELIMINAR" 
                                                                    onClick={()=>deletTool(
                                                                        item.idsL, item.idL, item.codL, 
                                                                        item.nomL, item.estL)} >
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-center foot">
                            <button type="button" className="btn btn-secondary"  onClick={cancelar} >CANCELAR</button>
                            {lista.length === 0 ? (
                                <button type="button" className="btn btn-light btncolor" disabled>ACEPTAR</button> 
                            ):(
                                <button type="button" className="btn btn-light btncolor"  data-bs-toggle="modal" data-bs-target="#modal-devolver">ACEPTAR</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="modal-devolver" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog ">
                    <div className="modal-content">
                    <div className="modal-header btncolor" >
                        <h5 className="modal-title" id="exampleModalLabel">SELECIONAR EMPLEADO</h5>
                        <button type="button" className="btn-close bg-white" data-bs-toggle="modal" data-bs-target="#modal-entrada" aria-label="Close" ></button>
                    </div>
                        <div className="divO">
                            <label className="obligatorio">Obligatorio *</label>  
                        </div>
                    <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE DEL EMPLEADO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                            <input value={nomEmp} className="form-control" disabled />
                        </div>
                        <div className="mb-3" id="divpin">
                            <label className="form-label">INGRESE EL PIN DEL EMPLEADO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                            <input type="password" style={{textAlign:'center'}} minLength={4} maxLength={4} className="form-control"  id="pin" 
                            onChange={e => setPinEmpleado(e.target.value)} required  />
                        </div>          
                    </div>
                    <div className="modal-footer justify-content-center">
                        <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modal-entrada">CANCELAR</button>                                               
                        <button type="submit" className="btn btn-light btncolor" onClick={confirmarCredenciales}>ACEPTAR</button>                                                
                    </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="modal-agregar-nota" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header btncolor" >
                            <h5 className="modal-title" id="exampleModalLabel">VERIFICAR ESTADO DE HERRAMIENTA</h5>
                            <button type="button" className="btn-close bg-white" data-bs-toggle="modal" data-bs-target="#modal-entrada" aria-label="Close" ></button>
                        </div>
                        <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                        <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                            <div className="mb-3" style={{textAlign:'center'}}>
                                <strong><label htmlFor="exampleFormControlInput1" className="form-label text-uppercase">
                                    CODIGO: {codigoH}
                                </label></strong>
                            </div>
                            <div className="mb-3" style={{textAlign:'center'}}>
                                <strong><label htmlFor="exampleFormControlInput1" className="form-label text-uppercase">
                                    HERRAMIENTA: {nombreH} 
                                </label></strong>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">HERRAMIENTA DAÑADA:<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <div onChange={e => setVerificar(e.target.value)} >
                                    <div className="form-check" >
                                        <input className="form-check-input" type="radio" value="si" name="estado" id="opcion1" onClick={notasi} required/>
                                        <label className="form-check-label" >
                                            SI
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" value="no" name="estado" id="opcion2" onClick={notano} />
                                        <label className="form-check-label" >
                                            NO
                                        </label>
                                    </div>                               
                                </div>
                            </div>
                            <div className="mb-3" id="divobservacion" style={{display:'none'}}>
                                <label htmlFor="exampleFormControlInput1" className="form-label">OBSERVACION:<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="text" className="form-control"  id="inputobservacion" required 
                                onChange={e => setObservacionH(e.target.value) }/>
                            </div>
                            <div className="mb-1">
                                <label htmlFor="exampleFormControlInput1" style={{fontSize:'15px', color:'red'}} className="form-label">
                                    NOTA: SI LA HERRAMIENTA ESTA DAÑADA ELIJA SI, AGREGUE UNA OBSERVACION
                                    Y PULSE CONTINUAR, DE LO CONTARIO ELIJA NO Y PULSE CONTINUAR.
                                </label>
                            </div>             
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modal-entrada">CANCELAR</button>
                            {verificar === null ? (
                                <button type="button" className="btn btn-light btncolor" disabled>CONTINUAR</button>
                            ):(
                                <button type="button" className="btn btn-light btncolor" onClick={addTool} data-bs-toggle="modal" data-bs-target="#modal-entrada" >CONTINUAR</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEntrada;